import React from 'react';
import { Box, Typography, useTheme } from '@material-ui/core';
import { Add } from '@material-ui/icons';

const AccessPointsEmpty = () => {
  const { shape, palette } = useTheme();
  return (
    <Box
      textAlign="center"
      display="flex"
      flex="auto"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Box p={2}>
        <Typography color="textSecondary" variant="h5">Looks like there are no WiFi yet.</Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Typography color="textSecondary">
          Click
        </Typography>
        <Box
          display="inline-flex"
          bgcolor={palette.primary.main}
          borderRadius={shape.borderRadius}
          color="white"
          justifyContent="center"
          alignItems="center"
          px={2}
          py={1}
          mx={1}
        >
          <Box fontSize="20px" display="flex">
            <Add fontSize="inherit" />
          </Box>
          <Box pl={1}>
            <Typography variant="body2">Add</Typography>
          </Box>
        </Box>
        <Typography color="textSecondary">
          to create your Wi-Fi.
        </Typography>
      </Box>
    </Box>
  );
};

export default AccessPointsEmpty;
